import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },

    list: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',

      '&:not(:empty)': {
        backgroundColor: colours.neutral[200],
        borderRadius: 8,
        padding: spacing(2),
        gap: spacing(2),
      },
    },
    draggableListRoot: {
      width: '100%',
    },
    draggableListItem: {
      width: '100%',
    },
    lookupCard: {
      width: '100%',
    },
  });
